<script lang="ts">
	import { faqGeneral as categories } from '$lib/data/faq';
	import MetaHead from '$lib/components/MetaHead.svelte';

	let openItems: Record<string, boolean> = $state({});
	let { data } = $props();

	function toggle(id: string) {
		openItems[id] = !openItems[id];
		openItems = openItems;
	}
</script>

<MetaHead {data} />

<!-- Hero -->
<section
	class="bg-gradient-to-b from-primary/5 to-transparent px-4 py-16 text-center dark:from-primary/10"
>
	<div class="mx-auto max-w-2xl">
		<span
			class="dark:text-primary-400 mb-4 inline-block rounded-full bg-primary/10 px-3 py-1 text-sm font-medium text-primary dark:bg-primary/20"
		>
			FAQ
		</span>
		<h1 class="mb-4 text-4xl font-bold text-gray-900 dark:text-white">Questions fréquentes</h1>
		<p class="text-lg text-gray-600 dark:text-gray-400">
			Tout ce que vous avez besoin de savoir avant de vous lancer. Vous ne trouvez pas votre réponse
			?
			<a
				href="/contact"
				class="text-primary underline underline-offset-4 transition-opacity hover:opacity-80"
				>Contactez-moi.</a
			>
		</p>
	</div>
</section>

<!-- Navigation par catégorie -->
<nav
	class="sticky top-16 z-10 border-b border-gray-200 bg-white/80 backdrop-blur dark:border-gray-800 dark:bg-gray-950/80"
>
	<div class="scrollbar-hide mx-auto flex max-w-4xl gap-2 overflow-x-auto px-4 py-3">
		{#each categories as cat}
			<a
				href="#{cat.id}"
				class="flex flex-shrink-0 items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-medium
               text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900
               dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white"
			>
				<span>{cat.icon}</span>
				<span>{cat.title}</span>
			</a>
		{/each}
	</div>
</nav>

<!-- Contenu FAQ -->
<main class="mx-auto max-w-4xl space-y-14 px-4 py-12">
	{#each categories as cat}
		<section id={cat.id}>
			<!-- Titre de catégorie -->
			<div class="mb-6 flex items-center gap-3">
				<span class="text-2xl">{cat.icon}</span>
				<h2 class="text-2xl font-bold text-gray-900 dark:text-white">{cat.title}</h2>
				<span class="ml-auto text-sm text-gray-400 dark:text-gray-500">
					{cat.questions.length} question{cat.questions.length > 1 ? 's' : ''}
				</span>
			</div>

			<!-- Accordéons -->
			<div class="space-y-3">
				{#each cat.questions as item, i}
					{@const id = `${cat.id}-${i}`}
					<div
						class="overflow-hidden rounded-xl border border-gray-200 bg-white
                   shadow-sm transition-shadow hover:shadow-md dark:border-gray-800 dark:bg-gray-900"
					>
						<button
							onclick={() => toggle(id)}
							class="flex w-full items-center justify-between gap-4 px-6 py-4 text-left
                     transition-colors hover:bg-gray-50 dark:hover:bg-gray-800/50"
							aria-expanded={openItems[id] ?? false}
						>
							<span class="text-[15px] leading-snug font-medium text-gray-900 dark:text-white">
								{item.q}
							</span>
							<span
								class="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full
                       bg-gray-100 text-gray-500 transition-transform duration-200
                       dark:bg-gray-800 dark:text-gray-400"
								class:rotate-180={openItems[id]}
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="14"
									height="14"
									fill="none"
									viewBox="0 0 24 24"
									stroke="currentColor"
									stroke-width="2.5"
								>
									<path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
								</svg>
							</span>
						</button>

						{#if openItems[id]}
							<div
								class="border-t border-gray-100 px-6 pt-4 pb-5 text-sm
                       leading-relaxed text-gray-600 dark:border-gray-800 dark:text-gray-400"
							>
								{item.a}
							</div>
						{/if}
					</div>
				{/each}
			</div>
		</section>
	{/each}

	<!-- CTA bas de page -->
	<div class="rounded-2xl border border-primary/20 bg-primary/5 p-8 text-center dark:bg-primary/10">
		<h3 class="mb-2 text-xl font-bold text-gray-900 dark:text-white">
			Vous avez une autre question ?
		</h3>
		<p class="mb-6 text-sm text-gray-600 dark:text-gray-400">
			Je réponds personnellement à chaque message sous 24h ouvrées.
		</p>
		<a
			href="/contact"
			class="inline-flex items-center gap-2 rounded-xl bg-primary px-6 py-3
             font-semibold text-white transition-colors hover:bg-primary/90"
		>
			Poser ma question
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="16"
				height="16"
				fill="none"
				viewBox="0 0 24 24"
				stroke="currentColor"
				stroke-width="2"
			>
				<path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
			</svg>
		</a>
	</div>
</main>
